import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=e21ae2dc&"
import script from "./Info.vue?vue&type=script&lang=ts&"
export * from "./Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports